import { getUserToken } from "@/utils/Cookie";
import store from "@/store/index";
let qs = require("qs");
let token = getUserToken();
export let request = (url, data = {}) => {
  return new Promise((resolve) => {
    var xhr = null;
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest();
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status == 304) {
          let res = JSON.parse(xhr.responseText);
          console.log(res);
          resolve(res);
        } else {
          console.log("出错" + xhr.status);
        }
      }
    };
    xhr.open("POST", store.state.baseURL + url, true);
    if (token) {
      xhr.setRequestHeader("token", token);
      console.log(token);
    }
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(qs.stringify(data));

    /* xhr.setRequestHeader("Content-type", "application/json; charset=UTF-8");
    xhr.send(JSON.stringify(data)); */
  });
};
export let request1 = (url, data = {}) => {
  return new Promise((resolve) => {
    var xhr = null;
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest();
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status == 304) {
          let res = JSON.parse(xhr.responseText);
          console.log(res);
          resolve(res);
        } else {
          console.log("出错" + xhr.status);
        }
      }
    };
    xhr.open("POST", store.state.ledianyunURL + url, true);
    if (token) {
      xhr.setRequestHeader("token", token);
    }

    xhr.setRequestHeader("Content-type", "application/json; charset=UTF-8");
    xhr.send(JSON.stringify(data));
  });
};



export let https = (url, data = {}) => {
  return new Promise((resolve) => {
    var xhr = null;
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest();
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status == 304) {
          let res = JSON.parse(xhr.responseText);
          // console.log(res);
          resolve(res);
        } else {
          console.log("出错" + xhr.status);
        }
      }
    };
    xhr.open("POST", store.state.ledianyunURL + url, true);
    if (token) {
      xhr.setRequestHeader("token", token);
      console.log(token);
    }
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
 
   
    console.log(data, "所有参数");
    xhr.send(qs.stringify(data));
  });
};
